module.exports = __webpack_public_path__ + "static/img/70032A_X_02_20170801_LC.aaa2820.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/70032A_X_02_20170801_LC.png
// module id = elw8
// module chunks = 0